import * as THREE from 'three';

export interface Stage {
  renderer: THREE.WebGLRenderer;
  scene: THREE.Scene;
  /** Keeps cameras' aspect current; returns the viewport size. */
  resize(cameras: Array<THREE.PerspectiveCamera | THREE.OrthographicCamera>): {
    width: number;
    height: number;
  };
}

export function createStage(canvas: HTMLCanvasElement): Stage {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    powerPreference: 'high-performance',
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFShadowMap;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;

  const scene = new THREE.Scene();
  scene.background = new THREE.Color('#0b0d14');
  scene.fog = new THREE.Fog('#0b0d14', 90, 220);

  return {
    renderer,
    scene,
    resize(cameras) {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      renderer.setSize(width, height, false);
      for (const cam of cameras) {
        if (cam instanceof THREE.PerspectiveCamera) {
          cam.aspect = width / height;
        } else {
          const half = cam.userData['halfHeight'] as number | undefined;
          if (half) {
            cam.left = -half * (width / height);
            cam.right = half * (width / height);
            cam.top = half;
            cam.bottom = -half;
          }
        }
        cam.updateProjectionMatrix();
      }
      return { width, height };
    },
  };
}
